var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[(!_vm.isTrue)?_c('indexPc'):_vm._e(),(_vm.isTrue)?_c('indexH5'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }